<template>
  <div class="ui stackable menu">
    <div class="ui container">
      <router-link
        :to="{ name: 'Patients' }"
        class="item">
        {{ $tc('patient', 2) }}
      </router-link>
      <router-link
        :to="{ name: 'Actions'}"
        class="item">
        {{ $tc('action', 2) }}
      </router-link>
      <router-link
        :to="{ name: 'Lessons' }"
        class="item">
        {{ $tc('lesson', 2) }}
      </router-link>
      <!--<router-link-->
      <!--  :to="{ name: 'Assessments' }"-->
      <!--  class="item">-->
      <!--  {{ $tc('assessment', 2) }}-->
      <!--</router-link>-->
      <router-link
        :to="{ name: 'FAQs'}"
        class="item">
        {{ $tc('faq', 2) }}
      </router-link>
      <div class="right menu">
        <language-toggle/>
        <a
          v-if="userAuthToken !== null"
          @click="logout"
          class="item">
          {{ $t('login.logout') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageToggle from './menu/LanguageToggle'
import { mapState, mapMutations } from 'vuex'
import { deleteAllCookies } from '../mixins/cookies'

export default {
  name: 'TopMenu',
  components: {
    LanguageToggle
  },
  computed: {
    ...mapState(['userAuthToken'])
  },
  methods: {
    ...mapMutations(['setUser', 'resetStore']),

    logout () {
      deleteAllCookies()
      this.resetStore()
      if (this.$route.name !== 'Patients') {
        this.$router.push({ name: 'Patients' })
      }
      // NOTE: Original code
      // document.cookie = `migraineCare_xiG1Zg2MW5_UserId=; expires=${new Date(0)}`
      // document.cookie = `migraineCare_xiG1Zg2MW5_UserEmail=; expires=${new Date(0)}`
      // document.cookie = `migraineCare_xiG1Zg2MW5_UserAuthToken=; expires=${new Date(0)}`
      // document.cookie = `migraineCare_xiG1Zg2MW5_UserIsCoachOrAdmin=; expires=${new Date(0)}`
    }
  }
}
</script>
